const patientNameCollator = new Intl.Collator("es-MX", {
  sensitivity: "base",
  numeric: true,
  ignorePunctuation: true
})

function getPatientSortName(patient) {
  return `${patient?.firstName || ""} ${patient?.lastName || ""}`.trim()
}

function sortPatientsNaturally(rows) {
  return [...(rows || [])].sort((a, b) =>
    patientNameCollator.compare(getPatientSortName(a), getPatientSortName(b))
  )
}

export function patientNeedsRecall(patient) {
  if (!patient) return false

  const pendingBalance = Number(patient.pendingBalance || patient.balance || 0)
  const activePlans = Number(patient.activePlans || 0)

  if (pendingBalance > 0) return true
  if (activePlans > 0) return true

  const lastVisitRaw =
    patient.lastVisit ||
    patient.lastAppointment ||
    patient.lastAppointmentDate ||
    patient.updatedAt ||
    patient.createdAt

  if (!lastVisitRaw) return true

  const lastVisitDate = new Date(lastVisitRaw)
  if (Number.isNaN(lastVisitDate.getTime())) return true

  const now = new Date()
  const diffMs = now.getTime() - lastVisitDate.getTime()
  const diffDays = diffMs / (1000 * 60 * 60 * 24)

  return diffDays >= 180
}

export function filterPatientsBySegment(patients, activeFilter) {
  let rows = [...(patients || [])]

  if (activeFilter === "DEBT") {
    rows = rows.filter((p) => Number(p.pendingBalance || p.balance || 0) > 0)
  }

  if (activeFilter === "PLAN") {
    rows = rows.filter((p) => Number(p.activePlans || 0) > 0)
  }

  if (activeFilter === "RECALL") {
    rows = rows.filter((p) => patientNeedsRecall(p))
  }

  return sortPatientsNaturally(rows)
}

export function buildPatientModuleMetrics(patients) {
  const rows = patients || []

  return {
    total: rows.length,
    withDebt: rows.filter((p) => Number(p.pendingBalance || p.balance || 0) > 0).length,
    withPlans: rows.filter((p) => Number(p.activePlans || 0) > 0).length,
    recallPending: rows.filter((p) => patientNeedsRecall(p)).length
  }
}